export default class AddressEvents {

	constructor (datalistElements, toggleElements) {

		this.datalistElements = datalistElements;
		this.toggleElements = toggleElements;
		this.shippingSelector = document.getElementById('shipping_selector');
		this.billingSelector = document.getElementById('billing_selector');

		this.init();

	}

	init () {

		for (const elem of this.datalistElements) {
			elem.addEventListener('blur', () => this.setValue(elem));
		}

		for (const toggle of this.toggleElements) {
			toggle.addEventListener('click', () => this.toggleElement(toggle));
		}

		if (this.shippingSelector) {
			this.shippingSelector.addEventListener('change', () => this.toggleAllElements());
		}

		if (this.billingSelector) {
			this.billingSelector.addEventListener('change', () => this.toggleAllElements());
		}

	}

	setValue (elem) {

		const listId = elem.getAttribute('list');
		const listValue = this.checkOption(elem.value, listId);

		if (listValue) {
			elem.value = listValue;
		}

	}

	checkOption (entry, list) {

		const datalist = document.getElementById(list);

		if (!datalist) {
			return false;
		}

		const datalistOptions = datalist.getElementsByTagName('option');
		let value = '';

		for (let i = 0, len = datalistOptions.length; i < len; i++) {
			const option = datalistOptions[i];

			if (entry.toLowerCase() === option.value.toLowerCase() || entry.toLowerCase() === option.text.toLowerCase()) {
				value = option.value;
			}
		}

		return value;

	}

	toggleElement (toggle) {

		const elementId = toggle.getAttribute('data-address-toggle');
		const element = document.getElementById(elementId);

		if (element) {
			element.classList.remove('u-hidden');
			const firstInput = element.querySelector('input');

			if (firstInput) {
				firstInput.focus();
			}
		}

		toggle.style.display = 'none';

	}

	toggleAllElements () {

		for (const toggle of this.toggleElements) {
			const elementId = toggle.getAttribute('data-address-toggle');
			const element = document.getElementById(elementId);

			if (!element) {
				return;
			}

			const firstInput = element.querySelector('input');

			if (!firstInput) {
				return;
			}

			if (firstInput.value) {
				element.classList.remove('u-hidden');
				toggle.style.display = 'none';
			} else {
				element.classList.add('u-hidden');
				toggle.style.removeProperty('display');
			}
		}

	}
}
